import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosHandler } from "../lib/utils";
import { useSelector } from "react-redux";

const key = "articles";

export const useGetPaginatedTeams = ({
  page = 1,
  limit = 30,
  search = null,
  order,
  filters = {},
}) => {
  let url = `/admin/teams/paginated?page=${page}&limit=${limit}&order=${JSON.stringify(
    order
  )}`;
  if (search) url += `&search=${search}`;
  if (filters) url += `&filters=${JSON.stringify(filters)}`;

  const state = useSelector((state) => state);

  const query = useQuery({
    queryKey: [
      key,
      page,
      limit,
      search,
      JSON.stringify(order),
      JSON.stringify(filters),
    ],
    queryFn: async () =>
      await axiosHandler({
        url,
        method: "GET",
        state,
      }),
  });

  return query;
};

export const useGetTeam = ({ id }) => {
  const state = useSelector((state) => state);

  const query = useQuery({
    queryKey: [key, id],
    queryFn: async () =>
      await axiosHandler({
        url: `admin/teams/${id}`,
        method: "GET",
        state,
      }),
  });

  return query;
};

export const useCreateTeam = ({ onSuccess }) => {
  const queryClient = useQueryClient();
  const state = useSelector((state) => state);

  const mutation = useMutation({
    mutationFn: async (data) =>
      await axiosHandler({
        url: `admin/teams`,
        method: "POST",
        state,
        data,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(key);
      onSuccess?.();
    },
    onError: () => {
      queryClient.invalidateQueries(key);
    },
  });

  return mutation;
};

export const useUpdateTeam = ({ onSuccess }) => {
  const queryClient = useQueryClient();
  const state = useSelector((state) => state);

  const mutation = useMutation({
    mutationFn: async (data) => {
      delete data.logoUrl;
      return await axiosHandler({
        url: `admin/teams/${data.id}`,
        method: "PUT",
        state,
        data,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(key);
      onSuccess?.();
    },
    onError: () => {
      queryClient.invalidateQueries(key);
    },
  });

  return mutation;
};
